module.exports = __webpack_public_path__ + "img/297.de3a41d7.jpg";